import axios from "axios";
import { useState } from "react";

export default function UploadUsersCSV({listId}) {

  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);

  const handleUpload = async () => {

    if (!file) return alert("Select CSV file");

    const formData = new FormData();
    formData.append("file", file);
    

    const res = await axios.post(
      `https://api.ilogically.com/api/users/upload-csv?appToken=87adfacc2dffc65ae172d59a9f0badda&listId=${listId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    setResult(res.data);
  };

  return (
    <div>
      <h2>Upload Users CSV</h2>

      <input
        type="file"
        accept=".csv"
        onChange={(e) => setFile(e.target.files[0])}
      />

      <button onClick={handleUpload}>
        Upload
      </button>

      {result && (
        <div>
          <h3>Success</h3>
          <pre>{JSON.stringify(result.success, null, 2)}</pre>

          <h3>Failed</h3>
          <pre>{JSON.stringify(result.failed, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}